// extracted by mini-css-extract-plugin
module.exports = {"name":"businessPDP","className":"gcp-us-businessPDP"};